// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteItemModal-module__modal--3_prn","title":"DeleteItemModal-module__title--ngrkT","footer":"DeleteItemModal-module__footer--_eeyk"};